export const PlaceholderImage = ({ color }: { color: string }) => {
  return (
    <>
      <rect
        data-testid="placeholder-image"
        width="100%"
        height="100%"
        rx="16"
        fill={color}
        fillOpacity="0.4"
      />
      <path
        d="M542.416 240.026C542.416 251.729 539.18 262.676 533.554 272.022L480.292 364.274L427.026 272.014C421.403 262.67 418.168 251.726 418.168 240.026C418.168 205.716 445.982 177.902 480.292 177.902C514.602 177.902 542.416 205.716 542.416 240.026ZM480.292 260.734C491.729 260.734 501 251.463 501 240.026C501 228.589 491.729 219.318 480.292 219.318C468.855 219.318 459.584 228.589 459.584 240.026C459.584 251.463 468.855 260.734 480.292 260.734Z"
        fill={color}
      />
    </>
  );
};
